import { createAction, props } from '@ngrx/store';

export const FilterPanelActions = {
  init: createAction('[FilterPanel] init', props<{ filterInstanceId: string }>()),
  open: createAction('[FilterPanel] open'),
  close: createAction('[FilterPanel] close', props<{ destroy?: true }>()),
};
